import { DocumentTeleconsentType } from '../../../../../modules/teleconsent/types';
import {
  hasGrowthBookFeature,
  GrowthBookFeatures,
} from '../../../../../modules/core';

(function () {
  'use strict';

  angular
    .module('doxy.realtime.components.teleconsent.action.select', [])
    .directive('dTeleconsentSelect', function () {
      return {
        restrict: 'E',
        scope: {
          innerMediator: '=dInnerMediator',
        },
        bindToController: true,
        controller: 'TeleconsentSelectController as vm',
        templateUrl:
          '/app/realtime/components/teleconsent/action/select/' +
          'teleconsent.action.select.tpl.html',
      };
    })
    .controller(
      'TeleconsentSelectController',
      function TeleconsentSelectController(
        User,
        Document,
        institutionHelper,
        $scope,
        $rootScope,
        ActiveDocument,
        TeleconsentDocument
      ) {
        this.$onInit = async () => {
          const currentInstitution =
            await institutionHelper.getCurrentInstitution();

          let teleconsentDocuments = await ActiveDocument.getAvailable({
            institutionId: currentInstitution.id,
            includeDefaultForInstitution: true,
          }).$promise;

          teleconsentDocuments = teleconsentDocuments.map((document) => ({
            ...document,
            metadata:
              typeof document.metadata === 'string'
                ? JSON.parse(document.metadata)
                : document.metadata,
          }));

          this.documents = [...teleconsentDocuments];

          $rootScope.$evalAsync();
        };

        this.share = async (document) => {

          document = await TeleconsentDocument.findById({
            id: document.id,
          }).$promise;

          this.innerMediator.emit('share', document);
        };

        this.preview = async (document) => {

          document = await TeleconsentDocument.findById({
            id: document.id,
          }).$promise;

          this.innerMediator.emit('preview', document);
        };

        this.cancel = () => {
          this.innerMediator.emit('select:cancel');
        };
      }
    );
})();
